<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="'FORMS.EXPIRATION_DATE.VALID_TO' | translateControl : form | async">
        <app-input class="expirationDate-inputValidTo" [type]="'text'" [mainForm]="form" [controlName]="'validTo'"
          (click)="dpValidTo.toggle()" (keydown)="ignoreDatepickerInput($event)">
        </app-input>
        <app-input-datepicker class="expirationDate-inputDatepicker" [mainForm]="form" [controlName]="'validTo'"
          [value]="initialExpirationDate" [config]="{
            dateInputFormat: 'DD.MM.YYYY',
            showWeekNumbers: false,
            useUtc: false
          }" [range]="false" #dpValidTo>
        </app-input-datepicker>
      </app-form-row>
      <app-form-row [label]="'FORMS.EXPIRATION_DATE.DURATION' | translateControl : form | async">
        <app-input [type]="'number'" [mainForm]="form" [controlName]="'durationDays'" [suffix]="'days'">
        </app-input>
      </app-form-row>
    </div>
  </div>
</form>
